<template>
  <div>
    <vxe-card>
      <vxe-button content="button.return" icon="vxe-icon-arrows-left" mode="text" status="primary" @click="back"/>
    </vxe-card>
    <inventory-state-config ref="configs" :inventory-states="inventoryStates" :owners="owners" :warehouses="warehouses"/>
  </div>
</template>

<script>
import InventoryStateConfig from '@/views/basedata/orderType/InventoryStateConfig.vue'

export default {
  name: 'OrderTypeExtra',
  components: { InventoryStateConfig },
  props: {
    inventoryStates: { type: Array, default: () => [] },
    warehouses: { type: Array, default: () => [] },
    owners: { type: Array, default: () => [] }
  },
  methods: {
    back() {
      this.$emit('back')
    },
    refresh(type) {
      this.$refs.configs.refresh(type)
    }
  }
}
</script>